import { Div, H1, P } from '@dnb/eufemia';
import classNames from 'classnames';
import { type JSX, PropsWithChildren, ReactNode } from 'react';

import style from './index.module.css';

type HeroHeaderProps = PropsWithChildren<
  {
    heroText: string | undefined;
    wideHeader: boolean;
    heroSubtitle?: string | ReactNode;
    skeleton?: boolean;
    heroLeftComponent?: ReactNode;
  } & (
    | { backgroundImage: string; backgroundColor?: never; illustration?: never }
    | { backgroundImage?: never; backgroundColor: string; illustration: string | undefined }
  )
>;

const HeroHeader = ({
  backgroundImage,
  backgroundColor,
  illustration,
  heroText,
  wideHeader,
  heroSubtitle,
  children,
  skeleton = false,
  heroLeftComponent,
}: HeroHeaderProps): JSX.Element => {
  const titleLoading = skeleton && !heroText;

  return (
    <div
      className={style['HeroHeaderWrapper']}
      id="HeroHeader"
      style={backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : { backgroundColor }}
    >
      <div
        className={classNames(style['HeroTextContainer'], {
          [style['HeroTextContainerWide']!]: wideHeader,
        })}
      >
        <Div className={style['HeroText']}>
          {heroLeftComponent ?? (
            <>
              <H1 color="white" size="x-large" skeleton={titleLoading}>
                {titleLoading ? 'Loading...' : heroText}
              </H1>

              {heroSubtitle && typeof heroSubtitle === 'string' ? <P weight="medium">{heroSubtitle}</P> : heroSubtitle}
            </>
          )}
        </Div>
        {children && <div>{children}</div>}
        {illustration && <img alt="Banner illustration" className={style['Illustration']} src={illustration} />}
      </div>
    </div>
  );
};

export default HeroHeader;
